import React from 'react';
import { useTranslation } from 'next-i18next';
import styles from '../products.module.scss';

const NoSearchItemView: React.FC = () => {
  const { t } = useTranslation('orders-sales');

  return (
    <div className={styles.searchEmpty}>
      <div className={styles.searchEmpty_title}>{t('MY_ACCOUNT.ORDERS_SALES.LIST.SEARCH.NO_RESULTS')}</div>
      <div className={styles.searchEmpty_des}>{t('MY_ACCOUNT.ORDERS_SALES.LIST.SEARCH.NO_RESULTS_DESC')}</div>
    </div>
  );
};

export default NoSearchItemView;
